import { dynamic } from 'redux-saga-test-plan/providers'
import HeaderAccountSection from './HeaderAccountSection'
import HeaderMenu from './HeaderMenu/HeaderMenu'
import { HoverMenuProvider } from './HeaderMenu/HoverMenuContext'
import MobileMenu from './MobileMenu'
import { useHeaderMenuData } from './useHeaderMenuData'
import { useLocation } from 'react-router-dom'

function Header() {
  // Using static menu data until we have a backend endpoint returning the menu data.
  const menu = useHeaderMenuData()
  const location = useLocation() // <-- Get current route
  const isPodcastRoute = location.pathname.startsWith('/podcasts')

  return (
    <header>
      <nav>
        <HoverMenuProvider>
          <HeaderMenu menu={menu} isPodcastRoute={isPodcastRoute}>
            <div className='flex-1 justify-end'>
              <HeaderAccountSection>
                <MobileMenu menu={menu} className='px-6 flex lg:hidden' />
              </HeaderAccountSection>
            </div>
          </HeaderMenu>
        </HoverMenuProvider>
      </nav>
    </header>
  )
}

export default Header
